var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useDismiss, useFloating, useInteractions, useRole, } from '@floating-ui/react';
import { useId } from '../hooks';
import { Modal } from '../modal';
function DialogInternal(_a) {
    var _b = _a.alignCenter, alignCenter = _b === void 0 ? false : _b, children = _a.children, isOpen = _a.isOpen, onClose = _a.onClose, _c = _a.role, role = _c === void 0 ? 'dialog' : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, restProps = __rest(_a, ["alignCenter", "children", "isOpen", "onClose", "role", "size"]);
    var id = "modal-".concat(useId());
    var _e = useFloating({
        onOpenChange: onClose,
        open: isOpen,
    }), context = _e.context, refs = _e.refs;
    var getFloatingProps = useInteractions([
        useDismiss(context, {
            bubbles: false,
        }),
        useRole(context, { role: role }),
    ]).getFloatingProps;
    return (_jsx(Modal, __assign({}, __assign({ alignCenter: alignCenter, context: context, floatingProps: getFloatingProps({
            id: id,
            ref: refs.setFloating,
        }), isOpen: isOpen, onClose: onClose, size: size }, restProps), { children: children })));
}
export default DialogInternal;
